import React, {
    useCallback,
    useState, useEffect, useContext
} from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { messages } from 'gw-capability-policychange-common-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import styles from './QuotePage.module.scss';
import metadata from './QuotePage.metadata.json5';
//import UnderwritingIssues from 'nexus-components-platform-react/UnderwritingIssues/UnderwritingIssues';

function QuotePage(props) {
    const { wizardData, underwritingIssues } = props;
    const filterUWIssuesInCustomOffering = true;
    const { submissionVM } = wizardData;
    const { isLoggedIn } = useAuthentication();
    const [allValuable, setAllValuable] = useState();
    const [allMortgagee, setAllMortgagee] = useState();
    const translator = useContext(TranslatorContext);

    const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];
    const BLOCKS_BIND = 'BlocksBind';
    const NON_BLOCKING = 'NonBlocking';

    const getDisplayName = (propertyInfos, type) => {
        const availableTypeLists = propertyInfos
            .flat()
            .filter((val) => val.availableTypeListValues)
            .find((availableType) => availableType.id === 'ArticleType');
        const availableTypeListValues = availableTypeLists.availableTypeListValues || [];
        return availableTypeListValues.find((list) => list.code === type).displayKey;
    };

    useEffect(() => {
        const setValuableNames = () => {
            const valuable = _.get(
                submissionVM.value,
                'lobData.homeowners.offerings[0].coverages.schedules',
                []
            );
            const scheduleItems = valuable.map((valuables) => valuables.scheduleItems);
            const propertyInfos = valuable.map((valuables) => valuables.propertyInfos);
            const displayNames = _.flatMap(scheduleItems).map((item) => {
                return !_.isUndefined(item.itemData.ArticleType)
                    ? getDisplayName(propertyInfos, item.itemData.ArticleType.typeCodeValue)
                    : _.get(item, 'itemData.SchedItemDescriptionId.stringValue', '-');
            });
            setAllValuable(displayNames.join(', '));
        };

        const setMortgageeNames = () => {
            const mortgagee = _.get(
                submissionVM.value,
                'lobData.homeowners.coverables.additionalInterests',
                []
            );
            const mortgageeNames = mortgagee.map(
                (mortgagees) => mortgagees.policyAdditionalInterest
            );
            const displayNames = mortgageeNames.map((mortgageeName) => mortgageeName.displayName);
            setAllMortgagee(displayNames.join(', '));
        };
        if (isLoggedIn) {
            setValuableNames();
            setMortgageeNames();
        }
    }, [isLoggedIn, submissionVM]);

    const resolvers = {
        resolveClassNameMap: styles,
    };

    const findBlockingPoint = (type) => {
        return underwritingIssues.some((offeringIssue) => {
            if (type === BLOCKS_BIND) {
                return offeringIssue.currentBlockingPoint === BLOCKS_BIND;
            }
            return _.includes(BLOCKS_QUOTES, offeringIssue.currentBlockingPoint);
        });
    };

    const hasQuoteOrIssueBlockingUWIssues = () => {
        return submissionVM.status.value === 'Draft' || underwritingIssues.some((offeringIssue) => {
            return _.includes(BLOCKS_QUOTES, offeringIssue.currentBlockingPoint) || _.includes(BLOCKS_BIND, offeringIssue.currentBlockingPoint);
        });
    };

    const overrideProps = {
        valuables: {
            value: allValuable
        },
        mortgagee: {
            value: allMortgagee
        },
        underWritingIssues: {
            underwritingIssues: underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID: submissionVM.jobID.value,
            filterUWIssuesInCustomOffering,
            job:submissionVM.baseData.jobType.value
        },
        farmCostAndPremiumGrid: {
            visible: !findBlockingPoint(),
        },
        policyEffectiveDate: {
            visible: findBlockingPoint(),
        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [overrideProps, submissionVM]
    );

    return (
        <WizardPage disableNext={hasQuoteOrIssueBlockingUWIssues()}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                resolveValue={readValue}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default QuotePage;
